import { useEffect, useState } from "react"
import "./ScrollToTopButton.css"

const ScrollToTopButton = () => {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const toggleVisibility = () => {
      setVisible(window.pageYOffset > 200)
    }

    window.addEventListener("scroll", toggleVisibility)
    return () => window.removeEventListener("scroll", toggleVisibility)
  }, [])

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" })
  }

  return (
    visible && (
      <button
        className="scroll-to-top-btn"
        onClick={scrollToTop}
        aria-label="Scroll to top"
      >
        <span className="scroll-to-top-icon" aria-hidden="true" />
      </button>
    )
  )
}

export default ScrollToTopButton
